export const LOCAL_USER = "@sart_user";
export const LOCAL_ACTIVE_GRADE = "@sart_activeGrade";
export const LOCAL_ACTIVE_SCHOOL = "@sart_activeSchool";
